module.exports = __webpack_public_path__ + "static/media/star.ac05fe9f.svg";